import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Inter', sans-serif;
 } 
`;

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 50px;
  padding-left: 50px;

  @media screen and (max-width: 991px) {
    padding-right: 30px;
    padding-left: 30px;
  }
`;

export const Button = styled.button`
  border-radius: 4px;
  background: ${({ primary }) => (primary ? '#007ACC' : '#E0F2FF')}; // blue or light gray
  white-space: nowrap;
  padding: ${({ big }) => (big ? '12px 64px' : '10px 20px')};
  color: ${({ primary }) => (primary ? '#FFFFFF' : '#1F2937')}; // white or dark gray text
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease-out;

  &:hover {
    background: ${({ primary }) => (primary ? '#005FA3' : '#C7EAFE')}; // darker blue or gray
  }

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;


export const BookSessionButton = styled(Button)`
  background: #96DBF8;
  color: #000;

  &:hover {
    background: #72C9F0; /* slightly darker blue */
    color: #000;
  }
`;


export default GlobalStyle;
